export enum From {
  BOOKING = 'booking',
  FAVORITE = 'favorite',
}
